import React, {Component} from 'react';
import {Link} from 'react-router-dom'

import {findDOMNode} from 'react-dom';

export default class MenuHeader extends Component {

    componentDidMount() {
        require('../../../public/css/jquery.mmenu.all.css');
        require('../../../public/css/jquery.mmenu.positioning.css');
        require('../../../public/css/jquery.smartbanner.css');
        require('../../../public/js/libs/jquery.mmenu.all.min');

        $(findDOMNode(this.refs.rightMenu)).mmenu({
            offCanvas: {
                position: "right"
            }
        });
    }

    openMenu = () => {
        $(findDOMNode(this.refs.rightMenu)).data('mmenu').open();
    };

    closeMenu = () => {
        $(findDOMNode(this.refs.rightMenu)).data('mmenu').close();
    };

    render() {
        return (
            <div>
                <div className="header">
                    <div className="container inner">
                        <Link to="/">
                            <span className="logo"></span>
                        </Link>
                        <div className="menu" onClick={this.openMenu}></div>
                    </div>
                </div>
                <nav id="rightMenu" ref="rightMenu">
                    <ul>
                        <li><Link onClick={this.closeMenu} to="/">Beregning av frister</Link></li>
                        <li><Link onClick={this.closeMenu} to="/about">Om Fristberegneren</Link></li>
                        <li><Link onClick={this.closeMenu} to="https://www.kvale.no/kompetanse/fagomrader/offentlige-anskaffelser/" target="_blank">Kontakt oss</Link></li>
                        <li><Link onClick={this.closeMenu} to="/terms">Vilkår og betingelser</Link></li>
                    </ul>
                </nav>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MenuHeader.js